module.exports = __webpack_public_path__ + "static/media/procedureEng.a7f57722.png";